<template>
      <b-navbar class="navbar_component">
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img alt="logo" src="../assets/flatte.png">
            </b-navbar-item>
        </template>
         <template slot="end">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <span class="icon-home"></span>ホーム
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'Literatures' }">
                日本の文学
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'Conversion' }">
                テキスト変換
            </b-navbar-item>
            <b-navbar-dropdown label="シェア">
                <b-navbar-item @click="headerTwitterShare">
                    <span class="icon-twitter"> Twitter</span>
                </b-navbar-item>
                <b-navbar-item @click="headerFacebookShare">
                    <span class="icon-facebook">  facebook</span>
                </b-navbar-item>
            </b-navbar-dropdown>
        </template>
    </b-navbar>
</template>

<script>
export default {
    methods:{
        headerTwitterShare(){
            var header_twitter_share_url = 'https://twitter.com/intent/tweet?text=' + "%20%23Flatte" + "%20" + "https://flatte.ameneko.com" +  this.$route.path
            window.open(header_twitter_share_url, '_blank')
        },
        headerFacebookShare(){
            var header_facebook_share_url = 'https://www.facebook.com/sharer/sharer.php?u=' + "https://flatte.ameneko.com" +  this.$route.path;
            window.open(header_facebook_share_url, '_blank')
        }
    }
}
</script>

<style>
.navbar_component{
    max-width: 1200px;
    margin: auto;
    padding: 0 40px;
}
.brand{
    max-width: 56px;
}
</style>